import React from "react";
import { useTranslation } from "react-i18next";
import CustomizedAlert from "./Alert/CustomizedAlert";

const Translation = ({message,alertType}) => {
    const {t} = useTranslation();
    let finalMessage = '';
    message.forEach((item) => finalMessage += `${t(item)} `)

    let alertData = {
        'open': true,
        'showConfirm':'showNotification',
        'alertType': alertType,
        'alertContentMsg': finalMessage,
    };
    return(
    <CustomizedAlert alertData={alertData}/>
    );
}

export default Translation;